import { Grid, Paper } from "@mui/material";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";

import AuthPageLayout from "../layout/AuthPageLayout";
import LoadingIndicator from "../components/common/LoadingSpinner";
import { useUserAPI } from "../context/userAPIContext";
import { CustomToolbar } from "../components/common/CustomDataGridToolBar";
import { CustomModal } from "../components/common/CustomModal";
import { ADMIN_ROLE } from "../utils/constants";
import { getOpenPositions, postOpenPosition } from "../services/api/positions";

const createPositionModalProps = { 
  title: 'Create Position',
  description:
    'Backend response to create position:',
  confirmButtonText: 'Create',
  cancelButtonText: 'Cancel',
  confirmButtonColor: 'primary',
  variant: 'outlined',
};

export const Positions = () => {

  const positionsTableColumns = [
    {
      field: 'title',
      headerName: 'POSITION',
      minWidth: 150,
      flex: 1,
      headerClassName: 'header-style',
      headerAlign: 'center'
    },
    {
      field: 'description',
      headerName: 'DESCRIPTION',
      minWidth: 150,
      flex: 1,
      headerClassName: 'header-style',
      headerAlign: 'center'
    }
  ];

  const isAdmin = () => user.roles.demo && user.roles.demo.includes(ADMIN_ROLE);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [positions, setPositions] = useState([]);
  const { user, checkUserAuthentication } = useUserAPI();
  const [ messageCreate, setMessageCreate] = useState('');

  const createPosition = async () => {
    setOpenCreateModal(true)
    const message = await postOpenPosition();
    setMessageCreate(message);
  };

  useEffect(() => {
    checkUserAuthentication();
    const fetchPositions = async () => {
      setIsLoading(true);
      const fetchedPositions = await getOpenPositions();
      setPositions(fetchedPositions);
      setIsLoading(false);
    };

    fetchPositions();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <AuthPageLayout containerWidth='lg'>
        <Grid container direction="column">
            <Paper
              sx={{
                p: 5,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <Typography variant="h6" sx={{paddingBottom:1, fontWeight:"bold"}}>
                Open Positions
              </Typography>
              {
                isLoading ?
                (<LoadingIndicator />) :
                (
                  <div style={{ height: 390, width: '100%' }}>
                    <div style={{ display: 'flex', height: '100%' }}>
                      <div style={{ flexGrow: 1 }}>
                        <DataGrid
                          {...(isAdmin() ? {components: { Toolbar: () => <CustomToolbar addAction={createPosition}/> }}: {})}
                          sx={{ fontSize: 16, '& .header-style': {
                            fontSize: 18,
                          },}}
                          rows={positions}
                          columns={positionsTableColumns}
                          getRowId={(position) => position.id}
                          pageSize={10}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          disableColumnResize={false}
                          checkboxSelection={false}
                          autoPageSize={true}
                          getRowHeight={() => 'auto'}
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            </Paper>
          </Grid>
          <CustomModal
          {...createPositionModalProps}
          open={openCreateModal}
          handleClose={() => setOpenCreateModal(false)}
          handleConfirm={() => setOpenCreateModal(false)}
          handleCancel={() => setOpenCreateModal(false)}
          children={<h1>{messageCreate}</h1>}
        />
      </AuthPageLayout>
    </>
  )
};
